//数组对象去重 保留一个相同的个
let reduceSameOneArr = (arr, key) => {
    var obj = {};
    arr = arr.reduce(function (item, next) {
        obj[next[key]] ? '' : obj[next[key]] = true && item.push(next);
        return item;
    }, []);
    return arr
}

//数组去重  两个相同的数组 都删除 不保留
let reduceSameTwoArr = (firstArr, secondArr, key) => {
    let newArr = [];
    //filter()方法为测试所有元素  return true表示保留该元素（通过测试），false则不保留。
    newArr = firstArr.filter(item => {
        //返回第二个数组里面判断的标准 字段key 存为一个数组
        let sameKeyArr = secondArr.map(ele => ele[key]); // (ele=>ele.propID)  等价于 (ele)=>{reurn ele.propID} 
        //检测第二个数组sameKeyArr里面的key 是否跟第一个数组里面的key 一样  如果一样就true   但是最后需要两个相同的数组都删除 所以最后"!"取反返回 false 则不保留该相同的数组
        return !sameKeyArr.includes(item[key])
    })
    return newArr
}

export default {
    reduceSameOneArr,
    reduceSameTwoArr
}